import { useSelector } from "react-redux";
import { PackageIcon } from "@app/design-system/icons";
import { RootState } from "@app/store";
import { t } from "@app/utils/translation";
import styles from "./LogoTopBar.module.css";

export type LogoTopBarProps = {
  logoUrl: string;
  orderCode?: string;
  /** Withholds the order code — same gate as `TrackingHeader`/
   * `OrderDetailsHeader` use for dropoff-specific tracking links. */
  isDropoffTracking?: boolean;
};

/**
 * Logo + order-code header — the desktop shell's stand-in for a page's
 * normal back-button header on whichever screen is acting as the panel's
 * root (no "back" to go to). Content mirrors `TrackingHeader`'s top row
 * exactly (same logo treatment, same order-code badge); styled flat like
 * `OrderDetailsHeader` rather than floating "chrome" since the desktop panel
 * is a docked sidebar, not an overlay above the map.
 */
export const LogoTopBar = ({ logoUrl, orderCode, isDropoffTracking = false }: LogoTopBarProps) => {
  const language = useSelector((state: RootState) => state.setting.language);

  return (
    <header className={styles.header}>
      <img className={styles.logo} src={logoUrl} alt={t("CompanyLogo", language)} />
      {orderCode && !isDropoffTracking ? (
        <span className={styles.orderCode}>
          <PackageIcon size={20} />
          <span className={styles.orderCodeText}>{orderCode}</span>
        </span>
      ) : null}
    </header>
  );
};
